import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyAjVUbNqqkl4ThYbWpVu_JJqxpj55nijas',
  authDomain: 'rao-jatin-shop.firebaseapp.com',
  databaseURL: 'https://rao-jatin-shop-default-rtdb.firebaseio.com',
  projectId: 'rao-jatin-shop',
  storageBucket: 'rao-jatin-shop.firebasestorage.app',
  messagingSenderId: '18171839156',
  appId: '1:18171839156:web:0d1810ad73ea64993dcde1',
  measurementId: 'G-80M3MLLFF6'
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

let analyticsInstance = null;

export async function initAnalytics() {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const supported = await isSupported();
    if (supported) {
      analyticsInstance = getAnalytics(app);
    }
  } catch (_error) {
    analyticsInstance = null;
  }

  return analyticsInstance;
}

export function getAnalyticsInstance() {
  return analyticsInstance;
}
